import type { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    filesView: {
      backgroundColor: 'rgba(255, 255, 255, 0.09)',
      borderRadius: 4,
    },
    filesContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    visibilityFile: {
      width: '100%',
      display: 'flex',
      height: 'auto',
      flexWrap: 'wrap',
    },
    imageWidth: {
      userSelect: 'none',
      padding: '16px',
      width: '30%',
      height: '30%',
      margin: `0 0 8px 0px`,
      [theme.breakpoints.between(600, 1670)]: {
        userSelect: 'none',
        width: '50%',
        height: '50%',
        padding: '5px',
      },
    },
    headingBorder: {
      borderBottom: '1px solid',
    },
    droppleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '50%',
      height: 'auto',
      flexWrap: 'wrap',
      padding: '10px',
      borderLeft: '1px solid grey',
    },
    visibilityFileContainer: {
      width: '100%',
    },
    text: {
      fontSize: '16px',
    },
    droppableFile: {
      padding: '8px',
      width: '100%',
    },
  }),
);

export default useStyles;
